import React, { Component } from 'react';
import { Grid, Label, Divider, Button, Form } from 'semantic-ui-react'
import Select from 'react-select';
import * as moment from 'moment';
import axios from 'axios'
import { base, serverIp, getOrderKey } from '../../../../config/constants';
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import * as Utils from '../../../../Utilities/Utils'
import Status from '../../../../config/OrderStatusConstants.js'
import { getPrintValues } from '../algoliaDashboard/AlgoliaMiscUtils';


class DeliveryGuySms extends Component {
    constructor(props) {
        super(props);
        this.state = {
            deliveryPerson: '',
            receiptAmount: 0,
            // deliveryPersonChoices: [
            //     { value: 'kenneth', label: 'kenneth', category: 'deliveryPerson' },
            //     { value: 'martin', label: 'martin', category: 'deliveryPerson' },
            //     { value: 'mark', label: 'mark', category: 'deliveryPerson' },
            //     { value: 'gorden', label: 'gorden', category: 'deliveryPerson' },
            // ],
            deliveryPersonChoices: [],
        }
    }

    componentDidMount() {
       // getPrintValues("deliveryGuys", this.loadDelGuys);
    }

    loadDelGuys = (statuses) => {
        //  console.log("ddx12 ++++++ loadStatuses ");
        //  console.log("ddx121 statuses:" + JSON.stringify(statuses, null, 3));
        this.setState({ deliveryPersonChoices: statuses })
    }

    /**
* HANDLE DROPDOWN FOR ORDER ONE
*/
    handleDropDownChanges = (value) => {
        console.log("lst1 handleDropDownChanges");
        console.log('lst12 You\'ve sss:', value);
        console.log("lst13 category alone:" + value.category);
        console.log('lst14 You\'ve selected:', value.value + " " + value.category);
        console.log("lst15 -  this.props.itemSelected:" + this.state.itemSelected);
        console.log("lst16 - array index:" + this.props.arrayIndex);

        let newState = {};
        newState[value.category] = value.value;
        console.log("newState 1:" + JSON.stringify(newState, null, 3));

        //this.setState(newState);
        this.setState(newState);
    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }



    sendSms = () => {
        console.log("mk1 ++++++++++++++ selectDesigner");

        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdates = {
            deliveryPersonSms: this.state.deliveryPerson,
            lastUpdated: now,
            lastUpdatedBy: this.props.user.email,
            deliveryPersonSmsBy: this.props.user.email,
            status: Status.out_delivery
        }

        FbUtils.updateOrder(getOrderKey(this.props.order), orderUpdates);

        //INSERT STATUS UPDATE IN UPDATES.
        let updateText = Status.out_delivery + " - " + this.props.user.email.substring(0, 10);
        FbUtils.insertUpdateText(getOrderKey(this.props.order), updateText, this.props.user.email);

        axios.post(serverIp + 'sms/sendDeliveryGuyInfo', {
            apiKey: "asdfasdf@da7",
            order_num: this.props.order.order_num,
            adminEmail: this.props.user.email,
            deliveryPerson: this.state.deliveryPerson,
            receiptAmount: this.state.receiptAmount
        })
            .then(function (response) {
                console.log(response.data);
                alert(response.data.message)
            })
            .catch(function (error) {
                console.log(error);
                alert(error)
            });

    }

    render() {

    

        const sendButton = this.state.deliveryPerson !== '' && this.state.receiptAmount !== 0 && this.state.receiptAmount !== ''
            ? <Button onClick={this.sendSms}> SEND DEL SMS</Button>
            : ''

        const showExisting = this.props.order.deliveryPersonSms
            ? <div>
                <h4>del guy:{this.props.order.deliveryPersonSms} by: {this.props.order.deliveryPersonSmsBy}</h4>
            </div>
            : ''

        const wholeUi = (this.props.order.status !== Status.new && this.props.order.status !== Status.delivered)
            && (this.props.user.email === "ivanmworozi@gmail.com"
                || this.props.user.email === "deliveries@printboda.com"
                || this.props.user.email === "alijibril2@gmail.com")
            ? <div>
                <Divider horizontal>{'DEL SMS'}</Divider>
          
                {showExisting}
                <Select
                    name="form-field-name"
                    value={this.state.deliveryPerson}
                    options={this.props.deliveryPersonChoices}
                    onChange={this.handleDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
                <Form.Field>
                    <Form.Input
                        name={'receiptAmount'}
                        value={this.state.receiptAmount}
                        placeholder='Total Amount of Receipt'
                        type='number'
                        onChange={this.handleTextInputChange}
                    />
                </Form.Field>
                {sendButton}
            </div>
            : ''


        return (
            <div>
                {wholeUi}
            </div>
        )
    }
}

export default DeliveryGuySms;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/DeliveryGuySms/DeliveryGuySms.js